@switch (Scope.renderContext.RenderMode) {
    @case (WebsiteRenderMode.Website) {
        <lib-website-page
            [ID]="currentViewablePageID"
            [websiteMode]="WebsiteMode.Live"
            [websiteData]="Scope.website"
            [renderContext]="Scope.renderContext"
            [headerLogoID]="Scope.website.HeaderLogoMediaLibraryItemID!"
            (navigationPageClicked)="NavigationPageClicked($event)">
            <ng-template
                #textMediaBlockHeader
                let-block>
                <span [innerHTML]="block.Header | trustHtml"></span>
            </ng-template>
            <ng-template
                #textMediaBlockBody
                let-block>
                <span [innerHTML]="block.Body | trustHtml"></span>
            </ng-template>
            <ng-template
                #textMediaBlockImage
                let-imageItem
                let-blockType="blockType">
                @if (imageItem && imageItem.Hyperlink && !(blockType | method: IsHeroBlock)) {
                    <a class="d-flex h-100"
                        [href]="imageItem.Hyperlink"
                        [target]="imageItem.OpenInNewTab ? '_blank' : '_self'">
                        <ng-container *ngTemplateOutlet="img; context: { $implicit: imageItem, blockType: blockType, showCursorPointer: true }"></ng-container>
                    </a>
                } @else {
                    <ng-container *ngTemplateOutlet="img; context: { $implicit: imageItem, blockType: blockType, showCursorPointer: false }"></ng-container>
                }
            </ng-template>
            <ng-template
                #textMediaBlockImageHeader
                let-block>
                <span [innerHTML]="block.Header | trustHtml"></span>
            </ng-template>
            <ng-template
                #textMediaBlockImageBody
                let-block>
                <span [innerHTML]="block.Body | trustHtml"></span>
            </ng-template>
            <ng-template
                #htmlBlock
                let-block>
                <lib-iframe
                    class="w-100"
                    [minHeight]="100"
                    [src]="block.Body!"></lib-iframe>
            </ng-template>
            <div copyright>
                <p class="scss-copyright-typography">
                    © {{ currentYear }} {{ Scope.website.Title }}
                    <a
                        class="scss-copyright-typography"
                        i18n="@@WPWebsiteFooterPoweredBy"
                        [href]="hostname"
                        target="_blank">
                        Powered by #Product#
                    </a>
                </p>
            </div>
        </lib-website-page>
    }
    @case (WebsiteRenderMode.Widget) {
        @if (Scope.renderContext.SchoolActive) {
            <lib-website-block
                [websiteBlockData]="Scope.websiteBlock!"
                [renderContext]="Scope.renderContext"
                [hostingType]="Scope.website.HostingType"
                [scriptCodes]="Scope.website.ScriptCodes"></lib-website-block>
        } @else {
            <div class="margin-16">
                <lib-card>
                    <div class="d-flex flex-column justify-content-center align-items-center gap-4 mx-0 mx-lg-2 my-4">
                        <img src="assets/Widget-Signup-Form-Exclamation-Circle.svg" />
                        <h6
                            class="typography-semibold text-center"
                            i18n="@@WPSignupFormInactiveSchoolMessage">
                            This #studio# account is no longer active. Please log into your #product# account and update your membership settings to reactivate this
                            account.
                        </h6>
                    </div>
                </lib-card>
            </div>
        }
    }
}

<ng-template #img
    let-imageItem
    let-blockType="blockType"
    let-showCursorPointer="showCursorPointer">
    <lib-image
        *ngLet="
            imageItem && imageItem.Url
                ? (imageItem.Url | scaleImageUrl: blockType)
                : { src: 'assets/images/Website Block Text And Media - Placeholder - Square.svg', srcset: '' } as srcAttr"
        [offsetYPercent]="imageItem.OffsetYPercent"
        [offsetXPercent]="imageItem.OffsetXPercent"
        [imageScale]="imageItem.ImageScale"
        [showCursorPointer]="showCursorPointer"
        [alt]="imageItem && imageItem.AltText ? imageItem.AltText : ''"
        [srcset]="srcAttr.srcset"
        [src]="srcAttr.src">
    </lib-image>
</ng-template>
